import React from "react"
import { APP_TITLE } from "../../constants"
import { HeaderWrapper, HeaderContainer, Heading1 } from "../../UIKit/styles"
import Logo from "../Logo/Logo"

export default function Header(path) {
  return (
    <HeaderWrapper
    >
      <HeaderContainer>
          <Logo />
      <Heading1>{APP_TITLE}</Heading1>
       </HeaderContainer>
    </HeaderWrapper>
  )
}
